"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCorrectClass = exports.activateClickWithEnter = void 0;
const renderCorrectClass = (IE, mouse) => {
  if (IE && mouse) {
    return "ter-alert__icon ter-alert__icon-ie";
  } else if (!IE && mouse) {
    return "ter-alert__icon";
  } else if (!IE && !mouse) {
    return "ter-alert__icon tabFocus";
  }
};
exports.renderCorrectClass = renderCorrectClass;
const activateClickWithEnter = (event, name, mouse, onClick) => {
  if (!mouse) {
    // checks that a user hits the enter key to open the modal
    if (event?.keyCode === 13) {
      onClick(name);
    }
  }
};
exports.activateClickWithEnter = activateClickWithEnter;